module.exports = __webpack_public_path__ + "static/getinspired-hero-alt-201e0211955eebdf81ece2fdcc4d39a8.jpg";